import FasterRequest from '../network/FasterRequest';

class GetServerDateRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_HEAD;

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint(): string {
    return 'v1/ntp/localtime';
  }

  public query = (): string => '';
}

export default GetServerDateRequest;
